import { ApolloError } from '@apollo/client';
import type { NetworkError } from '@apollo/client/errors';
import { GraphQLFormattedError } from 'graphql';

export const isAuthError = (error: ApolloError | undefined): boolean => {
    if (!error) return false;

    return (
        isHttpUnauthorized(error.networkError) ||
        isGraphQLUnauthorized(error.graphQLErrors)
    );
};

export const isGraphQLUnauthorized = (
    graphQLErrors: readonly GraphQLFormattedError[] | undefined,
): boolean => {
    return (
        graphQLErrors?.some((error) => {
            const code = error.extensions?.code;
            const errorType = error.extensions?.errorType;
            return code === 401 || errorType === 'UNAUTHORIZED';
        }) ?? false
    );
};

export const isHttpUnauthorized = (
    networkError: NetworkError | undefined,
): boolean => {
    if (!networkError) return false;
    if ('statusCode' in networkError) {
        return networkError.statusCode === 401;
    }
    return false;
};
